import Component from '@cell/cell-core/component/component';
import { debounce } from '@cell/cell-core/utils';

import './product-gallery.scss';

class ProductGallery extends Component {
  constructor() {
    super();

    this.elements = {
      images: this.querySelectorAll('.ProductGallery__Image .Image'),
      prevButton: this.querySelector('[data-action="prev-gallery-item"]'),
      nextButton: this.querySelector('[data-action="next-gallery-item"]'),
    };

    this.currentSlideIndex = 0;

    this.handleSlide = this.handleSlide.bind(this);
    this.handleBulletClick = this.handleBulletClick.bind(this);
    this.handlePrevButtonClick = this.handlePrevButtonClick.bind(this);
    this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.slide-to-gallery-item', this.handleBulletClick);
    this.on('c-button.click.prev-gallery-item', this.handlePrevButtonClick);
    this.on('c-button.click.next-gallery-item', this.handleNextButtonClick);

    this.elements.images.forEach((imageElement, index) => {
      imageElement.on('click', () => {
        this.emit('open-zoom-modal', { index });
      });
    });

    this.querySelector('.ProductGallery__Slider').on('scroll', debounce(this.handleSlide, 100));
  }

  handleSlide(event) {
    // Calculate index based on the current scroll position. On mobile devices this calculation
    // can end up with a float number, so we round it to the nearest integer.
    const scrolledToSlideIndex = Math.round(event.target.scrollLeft / event.target.clientWidth);

    const navItemButtons = this.querySelectorAll('[data-action="slide-to-gallery-item"]');

    // Handle slide event just like a manual click on a nav item (bullet).
    this.handleBulletClick({
      target: navItemButtons[scrolledToSlideIndex],
    });
  }

  handleBulletClick(event) {
    const navItemElement = event.target.closest('[data-slide-index]');

    const clickedNavItemElementIndex = parseInt(
      navItemElement.getAttribute('data-slide-index'),
      10,
    );

    this.querySelectorAll('.ProductGallery__NavItem').forEach(
      (navItemElement, navItemElementIndex) => {
        if (navItemElementIndex === clickedNavItemElementIndex) {
          navItemElement.classList.add('ProductGallery__NavItem--Active');
          navItemElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } else {
          navItemElement.classList.remove('ProductGallery__NavItem--Active');
        }
      },
    );

    this.currentSlideIndex = clickedNavItemElementIndex;

    this.slideTo(this.currentSlideIndex);
  }

  handlePrevButtonClick() {
    this.currentSlideIndex -= 1;

    this.slideTo(this.currentSlideIndex);
  }

  handleNextButtonClick() {
    this.currentSlideIndex += 1;

    this.slideTo(this.currentSlideIndex);
  }

  slideTo(index, { smooth = true } = {}) {
    const sliderElement = this.querySelector('.ProductGallery__Slider');

    sliderElement.scrollTo({
      left: sliderElement.clientWidth * index,
      behavior: smooth ? 'smooth' : 'instant',
    });

    if (this.currentSlideIndex > 0) {
      // Enable the prev button if the current slide is not the first one
      this.elements.prevButton.enable();
    } else {
      // Disable the prev button if the current slide is the first one.
      this.elements.prevButton.disable();
    }

    if (this.currentSlideIndex >= this.elements.images.length - 1) {
      // Disable the next button if the current slide is the last one.
      this.elements.nextButton.disable();
    } else {
      // Disable the next button if the current slide is not the last one.
      this.elements.nextButton.enable();
    }
  }
}

customElements.define('product-gallery', ProductGallery);
